import { ToastContainer, toast } from "react-toastify";
import React, { useEffect, useState, useRef, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Col, Container, Row, Card, Button, Form, Accordion } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import Helmet from "react-helmet";
import Select from "react-select";
import moment from "moment";
import "../../App.css";
import Resultrecord from "./Resultrecord";
import { SessionContext } from "../SessionProvider";
import html2pdf from "html2pdf.js";

const ExamScheduleList = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  const navigate = useNavigate();
  const [selectedStudent, setStudent] = useOutletContext();
  const [smarks, setMarks] = useState([]);
  const receiptRef = useRef();
  const [resultrecord, setresultrecord] = useState([]);
  const [StudentDataresult, setStudentData] = useState([]);
  const [subjectArray, setSubjectArray] = useState([]);
  const [studentData, setStudentDetails] = useState(null);
  const [examScheduleData, setExamScheduleData] = useState([]);
  const [examScheduleDetails, setExamScheduleDetails] = useState([]);
  const [selectedExamTerm , setSelectedExamTerm] = useState(); // 19-Feb-2025 | sarfraj

  useEffect(() => {
    setSelectedExamTerm(null);
    setExamScheduleDetails([])
    setresultrecord([]);
    fetchData();
  }, [selectedStudent , selectedSessionId]);

  async function fetchData() {
    try {
      if (selectedStudent) {
        // let studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id);
        let studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id , selectedSessionId);
        console.log('studentDetails-->>' , studentDetails);
        
        setStudentDetails(studentDetails.studentRec ? studentDetails.studentRec : null);
        const result = await schoolApi.getStudentallResult(
          // selectedStudent.classid,
          // selectedStudent.student_addmission_id ? selectedStudent.student_addmission_id : selectedStudent.addmission_id ,
          studentDetails?.studentRec?.classid,
          studentDetails.studentRec?.student_addmission_id,
          selectedSessionId,
        );
        console.log('student-Result-->>' , result);
        

        if (result.success) {
          let studentRecord = {
            studentname: result?.results?.student_result.studentname,
            classname: result?.results?.student_result.classname,
            dateofbirth: result?.results?.student_result.dateofbirth,
            fathername: result?.results?.student_result.fathername,
            mothername: result?.results?.student_result.mothername,
            registration_no: result?.results?.student_result.registration_no,
            parentPhone: result?.results?.student_result.parentPhone,
            file_id: result?.results?.student_result.file_id,
            filetype: result?.results?.student_result.filetype,
            file_parent_id: result?.results?.student_result.file_parent_id,
          };

          const subjects = [];
          setStudentData(studentRecord);
          const resArr = result?.results?.student_result?.result;

          result?.results?.student_result?.result?.map((rs) => {
            rs?.data?.map((res) => {
              if (!subjects.some((sub) => sub.label === res.subject_id)) {
                subjects.push({ label: res.subject_id, value: res.subject });
              }
            });
          });

          const groupedData = {};

          for (const record of resArr) {
            const { exam_type } = record;
            if (!groupedData[exam_type]) {
              groupedData[exam_type] = [];
            }
            groupedData[exam_type].push(record);
          }

          const redddsult = Object.keys(groupedData).map((key) => ({
            exam_type: key,
            exams: groupedData[key],
          }));

          setSubjectArray(subjects);
          setMarks(redddsult);
        } else {
        }
  
        let examScheduleDetails = await schoolApi.searchExamScheduleRecords(selectedSessionId);
        console.log('examScheduleDetails-->>' , examScheduleDetails);
        
        if ( examScheduleDetails?.records && examScheduleDetails.records.length ) {
          const activeSchedules = examScheduleDetails.records.filter((item) => item.status === "Active");
          console.log('activeSchedules-->>' , activeSchedules);
          
          const schedulePromises = activeSchedules?.map(async (item) => {
            try {
              // const result = await schoolApi.fetchExamscheduleById(item.id, selectedStudent?.classid);
              const result = await schoolApi.fetchExamscheduleById(item.id, studentDetails?.studentRec?.classid,);
              console.log('fetchExamscheduleById-->>' , result);
              
              if (result.success) {
                console.log("Schedule fetched successfully for item ID:", item.id);
                return { value: item.id, label: item.name };
              } else {
                console.log("Failed to fetch schedule for item ID:", item.id);
                return null; // Return null if the API call fails or is unsuccessful
              }
            } catch (error) {
              console.error("Error fetching schedule for item ID:", item.id, error);
              return null;
            }
          });

          const resolvedSchedules = await Promise.all(schedulePromises);
          const validSchedules = resolvedSchedules.filter((schedule) => schedule !== null);

          setExamScheduleData(validSchedules);
        } else {
          setExamScheduleData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setExamScheduleDetails([]);
      setExamScheduleData([]); // mk empty if session-related exam-list not found
      setresultrecord([]);
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  }

  const saveAsPdf = async () => {
    const element = receiptRef.current; // Ensure this reference points to the receipt element
    const options = {
      margin: [0.5, 0.5, 0.5, 0.5],
      filename: "result.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    };

    // Directly save the PDF
    html2pdf().set(options).from(element).save();
  };

  const handleExamSchedule = async (e) => {
    try {
      if (!e.value) {
        return;
      }
      // 19-Feb-2025 | sarfraj
      const currentExamTerm = examScheduleData?.find((item) => item.value === e.value);
      setSelectedExamTerm(currentExamTerm);
      
      // const result = await schoolApi.fetchExamscheduleById(e.value, selectedStudent?.classid);
      const result = await schoolApi.fetchExamscheduleById(e.value, studentData?.classid);
      if (result.success && result.examSchedules) {
        setExamScheduleDetails(result.success ? result.examSchedules : []);
        if (e.label) {
          const filteredRecords = smarks.filter((item) => {return item.exam_type === e.label});

          if (filteredRecords.length > 0) {
            if (filteredRecords[0]?.exams[0]?.data) {
              setresultrecord(filteredRecords[0]?.exams);
            } else {
              setresultrecord([]);
            }
          } else {
            console.log("No matching records found.");
            setresultrecord([]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching exam schedule:", error);
      setExamScheduleDetails([]);
      setresultrecord([]);
      toast.error("No Record Found!!");
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  console.log('examScheduleData-->>' , examScheduleData);
  console.log('studentData-->>' , studentData);
  console.log("resultrecord->", resultrecord, " resultrecord.length", resultrecord)
  console.log("examScheduleDetails@@@=>", examScheduleDetails)

  return (
    <>
      <Helmet><title>Exam Schedule List</title></Helmet>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Card className="m-3 custom-card headerOfProject">
        <Row className="g-0">
          <Col lg={12} className="mx-2 text-center">
            <span
              className="te"
              style={{
                fontWeight: "Arial",
                fontSize: "17px",
              }}
            >
              Student Exam Information
            </span>
          </Col>
        </Row>
      </Card>
      <Container>
        <Form>
          <Row className="mx-2">
            <Col lg={2}>
              <Form.Group className="mx-2">
                <Form.Label className="form-view-label">Class Name</Form.Label>
                <Form.Control
                  name="classid"
                  value={studentData ? studentData?.classname : selectedStudent?.classname}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label" htmlFor="formBasicsalutation">Exam Title</Form.Label>
                <Select
                  required
                  className="custom-select username"
                  placeholder="Exam Name"
                  onChange={handleExamSchedule}
                  options={examScheduleData}
                  value={examScheduleData?.length > 0 ? selectedExamTerm : null }
                ></Select>
                <Form.Control.Feedback type="invalid">Please Select Students.</Form.Control.Feedback>
              </Form.Group>
            </Col>
            {resultrecord[0]?.data?.length > 0 && (
              <Col lg={7} className="mt-4 d-flex flex-row-reverse">
                <Button onClick={saveAsPdf}>
                  <i className="fa fa-download"></i> Result
                </Button>
                {resultrecord[0]?.data?.length > 0 &&  (
                  <div style={{ display: "none" }}>
                    <Resultrecord
                      ref={receiptRef}
                      StudentDataresult={StudentDataresult}
                      studentData={selectedStudent}
                      smarks={resultrecord}
                      subjectArray={subjectArray}
                    />
                  </div>
                )}
              </Col>
            )}
          </Row>
        </Form>
        {examScheduleDetails.length > 0 && (
          <Accordion className="mt-4 mx-4">
            {examScheduleDetails.map((exam, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header className="custom-accordion-header">
                  <Col lg={6}>
                  </Col>
                  <div className="header-content">
                    <b className="status">
                      {exam.subject} | &nbsp;&nbsp;
                      {moment(exam.schedule_date).format("DD-MMM-YYYY")}{" "}
                      |&nbsp;&nbsp;
                      {exam.status}
                      &nbsp;&nbsp;
                    </b>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Col lg={4}>
                      <Card className="mt-3">
                        <Card.Body className="text-center">
                          <Card.Title style={{ textAlign: "center" }}>
                            {moment(exam.schedule_date).format("dddd")}
                            <br />
                            {moment(exam.schedule_date).format("DD-MMM-YYYY")}
                          </Card.Title>
                        </Card.Body>
                      </Card>
                      <Card className="mt-3">
                        <Card.Title style={{ textAlign: "center" }} className="mt-2">
                          <i style={{ color: "tomato" }} className="fa-solid fa fa-clock-o fa-lg m-1"></i>
                          Exam Timing
                        </Card.Title>
                        <Card.Body className="text-center">
                          Start Time :{" "}
                          {moment(exam.start_time, "HH:mm:ss").format("hh:mm A")}
                          <br />
                          End Time :{" "}
                          {moment(exam.end_time, "HH:mm:ss").format("hh:mm A")}
                        </Card.Body>
                      </Card>
                      <Card className="mt-3">
                        <Card.Title
                          style={{ textAlign: "center" }}
                          className="mt-2"
                        >
                          <i
                            style={{ color: "tomato" }}
                            className="fa-solid fa fa-check fa-lg m-1"
                          ></i>
                          Marks Information
                        </Card.Title>
                        <Card.Body className="text-center">
                          Maximum Marks : {exam.max_marks}
                          <br />
                          Minimum Marks : {exam.min_marks}
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col lg={8}>
                      <Card className="mt-3">
                        <Card.Body>
                          <Card.Title>
                            <i
                              style={{ color: "tomato" }}
                              className="fa-solid fa-solid fa-school fa-lg m-2"
                            ></i>
                            Exam Information
                          </Card.Title>
                          <Row className="view-form">
                            <Col lg={6}>
                              <label>Examinor Name</label>
                              <span>{exam.examinor}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Exam Name</label>
                              <span>{exam.exam_title}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Subject Name</label>
                              <span>{exam.subject}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Session</label>
                              <span>{exam.session}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Status</label>
                              <span>{exam.status}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Date of Exam</label>
                              <span>
                                {moment(exam.schedule_date).format("DD-MM-YYYY")}
                              </span>
                            </Col>
                            <Col lg={6}>
                              <label>Practical</label>
                              <span>{exam.ispractical === false ? "No" : "Yes"}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Room No</label>
                              <span>{exam.room_no}</span>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
      </Container>
    </>
  );
};

export default ExamScheduleList;
